/* eslint-disable max-len */
const RatingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 25' fill='currentColor'>
    <path
      d='M13.4344 0L17.3353 8.06531L26.2114 9.28297L19.7462 15.4853L21.331 24.3031L13.4344 20.0711L5.53787 24.3031L7.12265 15.4853L0.657528 9.28297L9.53354 8.06531L13.4344 0Z'
      fill='currentColor'
    />
  </svg>
);

export { RatingIcon };
